import { Button, Marker } from '@design-systems/canvas-ui'
import { CustomTooltip } from 'mvscommoncomponents'
import { useEffect, useState } from 'react'
import { use } from 'react'
import { RFI_LAST_MODIFIED_DATE } from '../../common/commonConstants'

const AppliedFilterChips = ({
  allSelectedFilters = {},
  filterData = {},
  handleFilterUpdate,
  maxVisibleChips,
  setMaxVisibleChips,
}) => {
  const getDisplayValue = (filterKey, selectedId) => {
    const filterValues = filterData[filterKey]?.values || []

    const matchedValue = filterValues.find(
      (item) => String(item.id) === String(selectedId),
    )

    return matchedValue?.value || selectedId
  }

  const getDateLabel = (dateRange) => {
    if (dateRange?.displayValue) {
      return dateRange.displayValue
    }

    if (dateRange?.startDate && dateRange?.endDate) {
      return `${dateRange.startDate} - ${dateRange.endDate}`
    }

    return ''
  }

  const getChipLabel = (filterKey, selectedValue) => {
    if (filterKey === RFI_LAST_MODIFIED_DATE) {
      return getDateLabel(selectedValue)
    }

    const selectedLabels = selectedValue.map((selectedId) =>
      getDisplayValue(filterKey, selectedId),
    )

    const firstLabel = selectedLabels[0]
    const extraCount = selectedLabels.length - 1

    return extraCount > 0 ? `${firstLabel} +${extraCount}` : firstLabel
  }
  const getLabelForTooltip = (filterKey, selectedValue) => {
    if (filterKey === RFI_LAST_MODIFIED_DATE) {
      return [[selectedValue.startDate, selectedValue.endDate].join(' - ')]
    }

    const selectedLabels = selectedValue.map((selectedId) =>
      getDisplayValue(filterKey, selectedId),
    )

    return selectedLabels
  }

  const getTooltipText = (filterKey, selectedValue) => {
    const filterName = filterData[filterKey]?.name || filterKey

    if (filterKey === RFI_LAST_MODIFIED_DATE) {
      return `${filterName}: ${getDateLabel(selectedValue)}`
    }

    const selectedLabels = selectedValue.map((selectedId) =>
      getDisplayValue(filterKey, selectedId),
    )

    return `${filterName}: ${selectedLabels.join(', ')}`
  }

  const removeFilter = (filterKey) => {
    const updatedFilters = {
      ...allSelectedFilters,
    }

    delete updatedFilters[filterKey]
    handleFilterUpdate(updatedFilters)
  }

  const appliedFilterEntries = Object.entries(allSelectedFilters).filter(
    ([filterKey, selectedValue]) => {
      if (filterKey === RFI_LAST_MODIFIED_DATE) {
        return Boolean(selectedValue)
      }

      return Array.isArray(selectedValue) && selectedValue.length > 0
    },
  )

  const visibleChips = appliedFilterEntries.slice(0, maxVisibleChips)
  const extraCount = appliedFilterEntries.length - maxVisibleChips

  return (
    <div className="applied-filter-chip-container">
      {visibleChips.map(([filterKey, selectedValue]) => (
        <CustomTooltip
          key={`tooltip-for-${filterKey}`}
          placement="top"
          title={
            <>
              <div>{filterData[filterKey]?.name}:</div>
              {(getLabelForTooltip(filterKey, selectedValue) || []).map(
                (label) => (
                  <div key={label}>{label}</div>
                ),
              )}
            </>
          }
          arrow
          component={
            <Marker
              key={filterKey}
              color="grey"
              onRemove={() => removeFilter(filterKey)}
            >
              <span title={getTooltipText(filterKey, selectedValue)}>
                {getChipLabel(filterKey, selectedValue)}
              </span>
            </Marker>
          }
        />
      ))}

      {extraCount > 0 && (
        <Button
          className="hc8-pa-2x"
          variant="ghost"
          onClick={() => setMaxVisibleChips(appliedFilterEntries.length)}
        >
          <span
            className="active hc8-pl-none"
            title={appliedFilterEntries
              .map(([key, val]) => getTooltipText(key, val))
              .join(', ')}
          >
            <strong>+ {extraCount} more</strong>
          </span>
        </Button>
      )}
    </div>
  )
}

export default AppliedFilterChips
